
































































import { Messages } from "@/constants/messages";
import Vue from "vue";
import { App } from "@/model/App";
import img from "../assets/images_placeholder.jpg";
import { ROUTES } from "@/constants/routes";

export default Vue.extend({
  name: "AppCardPreview",
  data(): {
    mess: any;
    imageLoaded: boolean;
    iconLoaded: boolean;
    imgPlaceholder: any;
    srcBanner:string;
    srcIcon:string;
  } {
    return {
      mess: Messages,
      imageLoaded: false,
      iconLoaded: false,
      imgPlaceholder: img,
      srcBanner:"",
      srcIcon:"",
    };
  },
  computed: {
    getAltImage(): string {
      return this.app.appName + this.mess.ownership_banner;
    },
    getIconImage(): string {
      return this.app.appName + this.mess.ownership_icon;
    },
  },
  watch:{
    banner(){
      this.loadBanner();
    },
    icon(){
      this.loadIcon();
    }
  },
  created(){
    this.loadBanner();
    this.loadIcon();
  },
  methods: {
    loadBanner() {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (res) => {
          let img = new Image();
          img.src = (res.target as FileReader).result as string;
          this.srcBanner=img.src;
        };
        reader.onerror = (err) => reject(err);
        if (this.banner) {
          reader.readAsDataURL(this.banner as File);
        }
      });
    },
    loadIcon() {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (res) => {
          let img = new Image();
          img.src = (res.target as FileReader).result as string;
          this.srcIcon=img.src;
        };
        reader.onerror = (err) => reject(err);
        if (this.icon) {
          reader.readAsDataURL(this.icon as File);
        }
      });
    },
    loadedImage(): void {
      this.imageLoaded = true;
    },
    loadedIcon(): void {
      this.iconLoaded = true;
    },
    dealWithError(event: any): void {
      event.target.src = this.imgPlaceholder;
    },
    goToDetails(): void {
      this.$router.push({
        name: ROUTES.DETAILS_APP.name,
        params: { name: this.app.appName },
      });
    },
  },
  props: {
    app: {
      type: Object as () => App,
    },
    banner:{
      type:File,
      default:null,
    },
    icon:{
      type:File,
      default:null,
    }
  },
});
